import { fromJS } from 'immutable'
import {
  COMPANY_DEACTIVATE_REQUEST,
  COMPANY_DEACTIVATE_SUCCESS,
  COMPANY_DEACTIVATE_FAILURE,
  COMPANY_DEACTIVATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case COMPANY_DEACTIVATE_REQUEST:
      return state
        .set('isFetching', true)
    case COMPANY_DEACTIVATE_SUCCESS:
      return state
        .set('companyDeactivate', fromJS(action.payload.deleteCompany))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
        .set('isFetching', false)
    case COMPANY_DEACTIVATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('companyDeactivate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case COMPANY_DEACTIVATE_RESET:
      return state
        .delete('companyDeactivate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/company/company-deactivate-reducer.js